import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class StringAdapter implements JsonCustomConvert<string | string[] | undefined> {
    serialize(value: string | string[]): string | string[] | undefined {
        if (Array.isArray(value)) {
            return value.map((it) => String(it));
        }

        return value ? String(value) : undefined;
    }

    deserialize(value: any): string | string[] | undefined {
        if (Array.isArray(value)) {
            return value.map((it) => String(it));
        }

        return value ? String(value) : undefined;
    }
}
